import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function blockMissionToStaffTravelExpenses(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.missionToStaffs.blockMissionToStaffTravelExpenses.url, {
        id: affectedStaffId
      })
    )
    .post()
}

export async function unblockMissionToStaffTravelExpenses(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.missionToStaffs.unblockMissionToStaffTravelExpenses.url, {
        id: affectedStaffId
      })
    )
    .post()
}
